/**
 * SEO Data by Language - Complete metadata for all pages in EN, ES, VI
 */

export interface PageSEOData {
  title: string;
  description: string;
  h1: string;
  keywords?: string;
}

export interface SEODataByLanguage {
  en: PageSEOData;
  es: PageSEOData;
  vi: PageSEOData;
}

export const seoDataI18n: Record<string, SEODataByLanguage> = {
  // Home Page
  '/': {
    en: {
      title: 'Top Immigration Lawyer Houston',
      description: 'Leading immigration lawyer in Houston, TX specializing in asylum, naturalization, visas & deportation defense. Trilingual services (English/Spanish/Vietnamese). Call (832) 930-3059',
      h1: 'Houston Immigration & Legal Services',
      keywords: 'immigration lawyer Houston, Houston immigration attorney, asylum lawyer Houston'
    },
    es: {
      title: 'Mejor Abogado de Inmigración Houston',
      description: 'Abogado líder de inmigración en Houston, TX especializado en asilo, naturalización, visas y defensa contra deportación. Servicios trilingües. Llame (832) 356-7254',
      h1: 'Servicios Legales de Inmigración en Houston',
      keywords: 'abogado de inmigración Houston, abogado de asilo Houston'
    },
    vi: {
      title: 'Luật Sư Di Trú Hàng Đầu Houston',
      description: 'Luật sư di trú hàng đầu tại Houston, TX chuyên về tị nạn, nhập tịch, visa và phòng thủ trục xuất. Dịch vụ ba ngôn ngữ. Gọi (832) 987-6543',
      h1: 'Dịch Vụ Pháp Lý Di Trú tại Houston',
      keywords: 'luật sư di trú Houston, luật sư tị nạn Houston'
    }
  },

  // About Us
  '/about-us': {
    en: {
      title: 'About Us - Houston Immigration & Legal Firm',
      description: 'Meet Daniel Albert and our experienced legal team. Over 20 years serving Houston with immigration, family law, and comprehensive legal services.',
      h1: 'About Daniel Albert Law Firm'
    },
    es: {
      title: 'Sobre Nosotros - Firma Legal de Inmigración Houston',
      description: 'Conozca a Daniel Albert y nuestro equipo legal experimentado. Más de 20 años sirviendo a Houston con inmigración, derecho familiar y servicios legales completos.',
      h1: 'Sobre la Firma Daniel Albert Law'
    },
    vi: {
      title: 'Về Chúng Tôi - Công Ty Luật Di Trú Houston',
      description: 'Gặp gỡ Daniel Albert và đội ngũ luật sư giàu kinh nghiệm. Hơn 20 năm phục vụ Houston với di trú, luật gia đình và dịch vụ pháp lý toàn diện.',
      h1: 'Về Công Ty Luật Daniel Albert'
    }
  },

  // Practice Areas
  '/practice-areas': {
    en: {
      title: 'Legal Services Houston - Immigration, Family, Criminal Defense',
      description: 'Comprehensive legal services in Houston: Immigration, Criminal Defense, Personal Injury, Family Law, Business Law, Real Estate, Tax Law, and Probate.',
      h1: 'Our Practice Areas'
    },
    es: {
      title: 'Servicios Legales Houston - Inmigración, Familia, Defensa Criminal',
      description: 'Servicios legales completos en Houston: Inmigración, Defensa Criminal, Lesiones Personales, Derecho Familiar, Derecho Comercial, Bienes Raíces, Derecho Fiscal y Sucesiones.',
      h1: 'Nuestras Áreas de Práctica'
    },
    vi: {
      title: 'Dịch Vụ Pháp Lý Houston - Di Trú, Gia Đình, Biện Hộ Hình Sự',
      description: 'Dịch vụ pháp lý toàn diện tại Houston: Di Trú, Biện Hộ Hình Sự, Thương Tích Cá Nhân, Luật Gia Đình, Luật Kinh Doanh, Bất Động Sản, Luật Thuế và Di Chúc.',
      h1: 'Các Lĩnh Vực Hành Nghề Của Chúng Tôi'
    }
  },

  // Contact
  '/contact': {
    en: {
      title: 'Contact Houston Immigration Lawyer - Free Consultation',
      description: 'Contact Daniel Albert Law Firm in Houston, TX. Call (832) 930-3059 for English or (832) 356-7254 for Spanish. Free initial consultation.',
      h1: 'Contact Our Houston Law Office'
    },
    es: {
      title: 'Contactar Abogado de Inmigración Houston - Consulta Gratis',
      description: 'Contacte a la Firma Legal Daniel Albert en Houston, TX. Llame (832) 356-7254 para español o (832) 930-3059 para inglés. Consulta inicial gratuita.',
      h1: 'Contacte Nuestra Oficina Legal en Houston'
    },
    vi: {
      title: 'Liên Hệ Luật Sư Di Trú Houston - Tư Vấn Miễn Phí',
      description: 'Liên hệ Công Ty Luật Daniel Albert tại Houston, TX. Gọi (832) 987-6543 cho tiếng Việt hoặc (832) 930-3059 cho tiếng Anh. Tư vấn ban đầu miễn phí.',
      h1: 'Liên Hệ Văn Phòng Luật Houston Của Chúng Tôi'
    }
  },

  // Blog
  '/blog': {
    en: {
      title: 'Immigration Law Blog - Houston Legal Updates & Guides',
      description: 'Immigration law insights, legal guides, and updates from Houston immigration lawyer Daniel Albert. Stay informed on the latest immigration news.',
      h1: 'Legal Resources & Blog'
    },
    es: {
      title: 'Blog de Derecho de Inmigración - Actualizaciones Legales Houston',
      description: 'Perspectivas expertas sobre derecho de inmigración, guías legales y actualizaciones del abogado de inmigración Daniel Albert en Houston.',
      h1: 'Recursos Legales y Blog'
    },
    vi: {
      title: 'Blog Luật Di Trú - Cập Nhật Pháp Lý Houston',
      description: 'Thông tin chuyên sâu về luật di trú, hướng dẫn pháp lý và cập nhật từ luật sư di trú Daniel Albert tại Houston.',
      h1: 'Tài Nguyên Pháp Lý & Blog'
    }
  },

  // Immigration Services - Main
  '/practice-areas/immigration-services': {
    en: {
      title: 'Immigration Lawyer Houston - Visa, Green Card, Citizenship',
      description: 'Comprehensive immigration services in Houston: Family & employment visas, green cards, citizenship, asylum, deportation defense. Trilingual attorney.',
      h1: 'Immigration Services in Houston'
    },
    es: {
      title: 'Abogado de Inmigración Houston - Visa, Tarjeta Verde, Ciudadanía',
      description: 'Servicios completos de inmigración en Houston: Visas familiares y laborales, tarjetas verdes, ciudadanía, asilo, defensa contra deportación. Abogado trilingüe.',
      h1: 'Servicios de Inmigración en Houston'
    },
    vi: {
      title: 'Luật Sư Di Trú Houston - Visa, Thẻ Xanh, Quốc Tịch',
      description: 'Dịch vụ di trú toàn diện tại Houston: Visa gia đình và lao động, thẻ xanh, quốc tịch, tị nạn, phòng thủ trục xuất. Luật sư ba ngôn ngữ.',
      h1: 'Dịch Vụ Di Trú tại Houston'
    }
  },

  // Asylum Services
  '/practice-areas/immigration-services/asylum-services': {
    en: {
      title: 'Asylum Lawyer Houston - Protection from Persecution',
      description: 'Asylum services in Houston. Skilled representation for persecution victims. Affirmative & defensive asylum cases. Call (832) 930-3059.',
      h1: 'Asylum Services'
    },
    es: {
      title: 'Abogado de Asilo Houston - Protección Contra Persecución',
      description: 'Servicios de asilo en Houston. Representación experta para víctimas de persecución. Casos de asilo afirmativo y defensivo. Llame (832) 356-7254.',
      h1: 'Servicios de Asilo'
    },
    vi: {
      title: 'Luật Sư Tị Nạn Houston - Bảo Vệ Khỏi Bắt Bớ',
      description: 'Dịch vụ tị nạn tại Houston. Đại diện chuyên nghiệp cho nạn nhân bị bắt bớ. Các trường hợp tị nạn khẳng định và phòng thủ. Gọi (832) 987-6543.',
      h1: 'Dịch Vụ Tị Nạn'
    }
  },

  // Family-Based Immigration
  '/practice-areas/immigration-services/family-based-immigration': {
    en: {
      title: 'Family Immigration Lawyer Houston - Reunite with Loved Ones',
      description: 'Family-based immigration services in Houston. Spouse visas, K-1 fiancé visas, parent & children petitions. Experienced immigration attorney.',
      h1: 'Family-Based Immigration'
    },
    es: {
      title: 'Abogado de Inmigración Familiar Houston - Reúnase con Seres Queridos',
      description: 'Servicios de inmigración familiar en Houston. Visas de cónyuge, visas K-1 de prometido, peticiones de padres e hijos. Abogado de inmigración experimentado.',
      h1: 'Inmigración Basada en Familia'
    },
    vi: {
      title: 'Luật Sư Di Trú Gia Đình Houston - Đoàn Tụ Với Người Thân',
      description: 'Dịch vụ di trú gia đình tại Houston. Visa vợ/chồng, visa hôn phu K-1, đơn xin cha mẹ và con cái. Luật sư di trú giàu kinh nghiệm.',
      h1: 'Di Trú Theo Diện Gia Đình'
    }
  },

  // Citizenship & Naturalization
  '/practice-areas/immigration-services/citizenship-naturalization': {
    en: {
      title: 'Citizenship Lawyer Houston - Naturalization Services',
      description: 'Citizenship and naturalization services in Houston. N-400 application assistance, interview preparation, citizenship test help.',
      h1: 'Citizenship & Naturalization'
    },
    es: {
      title: 'Abogado de Ciudadanía Houston - Servicios de Naturalización',
      description: 'Servicios de ciudadanía y naturalización en Houston. Asistencia con solicitud N-400, preparación para entrevista, ayuda con examen de ciudadanía.',
      h1: 'Ciudadanía y Naturalización'
    },
    vi: {
      title: 'Luật Sư Quốc Tịch Houston - Dịch Vụ Nhập Tịch',
      description: 'Dịch vụ quốc tịch và nhập tịch tại Houston. Hỗ trợ đơn N-400, chuẩn bị phỏng vấn, trợ giúp thi quốc tịch.',
      h1: 'Quốc Tịch & Nhập Tịch'
    }
  },

  // Deportation Defense
  '/practice-areas/immigration-services/deportation-removal-defense': {
    en: {
      title: 'Deportation Defense Lawyer Houston - Stop Removal',
      description: 'Deportation and removal defense in Houston. Experienced immigration court representation. Fight deportation orders. Emergency assistance available.',
      h1: 'Deportation & Removal Defense'
    },
    es: {
      title: 'Abogado de Defensa Contra Deportación Houston - Detenga la Remoción',
      description: 'Defensa contra deportación y remoción en Houston. Representación experimentada en corte de inmigración. Luche contra órdenes de deportación. Asistencia de emergencia disponible.',
      h1: 'Defensa Contra Deportación y Remoción'
    },
    vi: {
      title: 'Luật Sư Phòng Thủ Trục Xuất Houston - Ngăn Chặn Trục Xuất',
      description: 'Phòng thủ trục xuất tại Houston. Đại diện có kinh nghiệm tại tòa di trú. Chống lại lệnh trục xuất. Hỗ trợ khẩn cấp có sẵn.',
      h1: 'Phòng Thủ Trục Xuất'
    }
  },

  // Criminal Defense - Main
  '/practice-areas/criminal-defense': {
    en: {
      title: 'Criminal Defense Lawyer Houston - Aggressive Legal Representation',
      description: 'Experienced criminal defense attorney in Houston. DWI, drug charges, assault, theft. Protect your rights and freedom. Call (832) 930-3059.',
      h1: 'Criminal Defense Services'
    },
    es: {
      title: 'Abogado de Defensa Criminal Houston - Representación Legal Agresiva',
      description: 'Abogado experimentado de defensa criminal en Houston. DWI, cargos de drogas, asalto, robo. Proteja sus derechos y libertad. Llame (832) 356-7254.',
      h1: 'Servicios de Defensa Criminal'
    },
    vi: {
      title: 'Luật Sư Biện Hộ Hình Sự Houston - Đại Diện Pháp Lý Mạnh Mẽ',
      description: 'Luật sư biện hộ hình sự giàu kinh nghiệm tại Houston. DWI, tội danh ma túy, tấn công, trộm cắp. Bảo vệ quyền và tự do của bạn. Gọi (832) 987-6543.',
      h1: 'Dịch Vụ Biện Hộ Hình Sự'
    }
  },

  // DWI Defense
  '/practice-areas/criminal-defense/dwi': {
    en: {
      title: 'DWI Lawyer Houston - Drunk Driving Defense Attorney',
      description: 'DWI defense lawyer in Houston. First offense, repeat DWI, felony DWI. Fight drunk driving charges. Protect your license and freedom.',
      h1: 'DWI Defense'
    },
    es: {
      title: 'Abogado DWI Houston - Defensa por Conducir Ebrio',
      description: 'Abogado de defensa DWI en Houston. Primera ofensa, DWI repetido, DWI con delito grave. Luche contra cargos de conducir ebrio. Proteja su licencia y libertad.',
      h1: 'Defensa DWI'
    },
    vi: {
      title: 'Luật Sư DWI Houston - Biện Hộ Lái Xe Say Rượu',
      description: 'Luật sư biện hộ DWI tại Houston. Vi phạm lần đầu, DWI lặp lại, DWI trọng tội. Chống lại cáo buộc lái xe say rượu. Bảo vệ bằng lái và tự do của bạn.',
      h1: 'Biện Hộ DWI'
    }
  },

  // Personal Injury - Main
  '/practice-areas/personal-injury': {
    en: {
      title: 'Personal Injury Lawyer Houston - Maximum Compensation',
      description: 'Personal injury attorney in Houston. Car accidents, truck crashes, medical malpractice. Fight for maximum compensation. No fee unless we win.',
      h1: 'Personal Injury Legal Services'
    },
    es: {
      title: 'Abogado de Lesiones Personales Houston - Compensación Máxima',
      description: 'Abogado de lesiones personales en Houston. Accidentes automovilísticos, choques de camiones, mala práctica médica. Luche por compensación máxima. Sin honorarios a menos que ganemos.',
      h1: 'Servicios Legales de Lesiones Personales'
    },
    vi: {
      title: 'Luật Sư Thương Tích Cá Nhân Houston - Bồi Thường Tối Đa',
      description: 'Luật sư thương tích cá nhân tại Houston. Tai nạn xe hơi, tai nạn xe tải, sai sót y khoa. Đấu tranh cho bồi thường tối đa. Không phí trừ khi thắng kiện.',
      h1: 'Dịch Vụ Pháp Lý Thương Tích Cá Nhân'
    }
  },

  // Family Law - Main
  '/practice-areas/family-law': {
    en: {
      title: 'Family Law Attorney Houston - Divorce, Custody, Child Support',
      description: 'Family law attorney in Houston. Divorce, child custody, child support, adoption, CPS defense. Compassionate representation for families.',
      h1: 'Family Law Services'
    },
    es: {
      title: 'Abogado de Derecho Familiar Houston - Divorcio, Custodia, Manutención',
      description: 'Abogado de derecho familiar en Houston. Divorcio, custodia de menores, manutención infantil, adopción, defensa CPS. Representación compasiva para familias.',
      h1: 'Servicios de Derecho Familiar'
    },
    vi: {
      title: 'Luật Sư Luật Gia Đình Houston - Ly Hôn, Quyền Nuôi Con, Cấp Dưỡng',
      description: 'Luật sư luật gia đình tại Houston. Ly hôn, quyền nuôi con, cấp dưỡng con, nhận con nuôi, biện hộ CPS. Đại diện thấu hiểu cho gia đình.',
      h1: 'Dịch Vụ Luật Gia Đình'
    }
  },

  // Business Law - Main
  '/practice-areas/business-law': {
    en: {
      title: 'Business Lawyer Houston - Formation, Contracts, Transactions',
      description: 'Business attorney in Houston. Business formation, contracts, partnerships, commercial transactions. Protect your business interests.',
      h1: 'Business Law Services'
    },
    es: {
      title: 'Abogado de Negocios Houston - Formación, Contratos, Transacciones',
      description: 'Abogado de negocios en Houston. Formación de negocios, contratos, asociaciones, transacciones comerciales. Proteja sus intereses comerciales.',
      h1: 'Servicios de Derecho Comercial'
    },
    vi: {
      title: 'Luật Sư Kinh Doanh Houston - Thành Lập, Hợp Đồng, Giao Dịch',
      description: 'Luật sư kinh doanh tại Houston. Thành lập doanh nghiệp, hợp đồng, quan hệ đối tác, giao dịch thương mại. Bảo vệ lợi ích kinh doanh của bạn.',
      h1: 'Dịch Vụ Luật Kinh Doanh'
    }
  },

  // Business Formation
  '/practice-areas/business-law/business-formation': {
    en: {
      title: 'Business Formation Lawyer Houston - LLC, Corporation Setup',
      description: 'Business formation attorney in Houston. LLC, corporation, partnership setup. Choose the right entity structure for your business.',
      h1: 'Business Formation'
    },
    es: {
      title: 'Abogado de Formación de Negocios Houston - LLC, Corporación',
      description: 'Abogado de formación de negocios en Houston. LLC, corporación, establecimiento de asociaciones. Elija la estructura de entidad adecuada para su negocio.',
      h1: 'Formación de Negocios'
    },
    vi: {
      title: 'Luật Sư Thành Lập Doanh Nghiệp Houston - LLC, Công Ty',
      description: 'Luật sư thành lập doanh nghiệp tại Houston. LLC, công ty, thiết lập quan hệ đối tác. Chọn cấu trúc pháp nhân phù hợp cho doanh nghiệp của bạn.',
      h1: 'Thành Lập Doanh Nghiệp'
    }
  },

  // Real Estate Law - Main
  '/practice-areas/real-estate-law': {
    en: {
      title: 'Real Estate Lawyer Houston - Closing, Transactions, Disputes',
      description: 'Real estate attorney in Houston. Residential and commercial closings, transactions, contracts, disputes. Protect your property investment.',
      h1: 'Real Estate Law Services'
    },
    es: {
      title: 'Abogado de Bienes Raíces Houston - Cierre, Transacciones, Disputas',
      description: 'Abogado de bienes raíces en Houston. Cierres residenciales y comerciales, transacciones, contratos, disputas. Proteja su inversión inmobiliaria.',
      h1: 'Servicios de Derecho de Bienes Raíces'
    },
    vi: {
      title: 'Luật Sư Bất Động Sản Houston - Đóng, Giao Dịch, Tranh Chấp',
      description: 'Luật sư bất động sản tại Houston. Đóng cửa nhà ở và thương mại, giao dịch, hợp đồng, tranh chấp. Bảo vệ đầu tư bất động sản của bạn.',
      h1: 'Dịch Vụ Luật Bất Động Sản'
    }
  },

  // Tax Law - Main
  '/practice-areas/tax-law': {
    en: {
      title: 'Tax Lawyer Houston - IRS Defense, Tax Planning',
      description: 'Tax attorney in Houston. IRS representation, tax debt resolution, tax planning, audit defense. Protect your financial interests.',
      h1: 'Tax Law Services'
    },
    es: {
      title: 'Abogado Fiscal Houston - Defensa IRS, Planificación Fiscal',
      description: 'Abogado fiscal en Houston. Representación ante el IRS, resolución de deuda tributaria, planificación fiscal, defensa de auditorías. Proteja sus intereses financieros.',
      h1: 'Servicios de Derecho Fiscal'
    },
    vi: {
      title: 'Luật Sư Thuế Houston - Biện Hộ IRS, Kế Hoạch Thuế',
      description: 'Luật sư thuế tại Houston. Đại diện IRS, giải quyết nợ thuế, kế hoạch thuế, biện hộ kiểm toán. Bảo vệ lợi ích tài chính của bạn.',
      h1: 'Dịch Vụ Luật Thuế'
    }
  },

  // Probate & Estate - Main
  '/practice-areas/probate-estate': {
    en: {
      title: 'Probate Lawyer Houston - Estate Planning, Wills, Trusts',
      description: 'Probate and estate planning attorney in Houston. Wills, trusts, probate administration, guardianship. Protect your legacy and loved ones.',
      h1: 'Probate & Estate Planning Services'
    },
    es: {
      title: 'Abogado de Sucesiones Houston - Planificación Patrimonial, Testamentos',
      description: 'Abogado de sucesiones y planificación patrimonial en Houston. Testamentos, fideicomisos, administración de sucesiones, tutela. Proteja su legado y seres queridos.',
      h1: 'Servicios de Sucesiones y Planificación Patrimonial'
    },
    vi: {
      title: 'Luật Sư Di Chúc Houston - Kế Hoạch Tài Sản, Di Chúc, Tín Thác',
      description: 'Luật sư di chúc và kế hoạch tài sản tại Houston. Di chúc, tín thác, quản lý di sản, giám hộ. Bảo vệ di sản và người thân của bạn.',
      h1: 'Dịch Vụ Di Chúc & Kế Hoạch Tài Sản'
    }
  }
};

/**
 * Get SEO data for a specific path and language
 */
export function getSEODataByLanguage(
  pathname: string,
  language: 'en' | 'es' | 'vi' = 'en'
): PageSEOData | undefined {
  const normalized = pathname.replace(/\/$/, '').toLowerCase();
  const data = seoDataI18n[normalized || '/'];
  return data?.[language];
}

/**
 * Get SEO data with fallback for unmapped pages
 */
export function getSEODataWithFallback(
  pathname: string,
  language: 'en' | 'es' | 'vi' = 'en'
): PageSEOData {
  const data = getSEODataByLanguage(pathname, language);
  
  if (data) return data;

  // Generate unique, language-aware fallbacks from the URL to avoid duplicate metadata
  const normalized = pathname.replace(/\/$/, '') || '/';
  const slug = normalized === '/' ? 'home' : normalized.split('/').filter(Boolean).slice(-1)[0];
  const toTitle = (s: string) => s
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

  const baseTitle = toTitle(slug);

  const templates = {
    en: {
      title: `${baseTitle} | Daniel Albert Law Firm`,
      description: `${baseTitle} legal services in Houston, TX. Experienced guidance and representation. Call (832) 930-3059 for a consultation.`,
      h1: baseTitle,
    },
    es: {
      title: `${baseTitle} | Firma Legal Daniel Albert`,
      description: `${baseTitle} en Houston, TX. Asesoría y representación legal experta. Llame al (832) 356-7254 para una consulta.`,
      h1: baseTitle,
    },
    vi: {
      title: `${baseTitle} | Công Ty Luật Daniel Albert`,
      description: `${baseTitle} tại Houston, TX. Tư vấn và đại diện pháp lý chuyên nghiệp. Gọi (832) 987-6543 để được tư vấn.`,
      h1: baseTitle,
    },
  } as const;

  return templates[language];
}
